import React from 'react'
import { Button, Icon, Header, Grid } from 'semantic-ui-react'
import MediaQuery from 'react-responsive'

import Mensagem from '../Sistema/Mensagem'
import IsDevIndicator from '../Ambiente/IsDevIndicator'
import Mensagens from '../../Mensagens';

class DetalheCongresso extends React.Component {

    render() {

        let icInscrito = this.props.eventosCongressista != null && this.props.eventosCongressista.length > 0
        let icAnyMarcouPresenca = icInscrito && this.props.eventosCongressista.filter(x => { return x.icMarcouPresenca }).length > 0

        return <div className="boxTop">

            {this.props.congresso &&

                <div>
                    {this.props.congresso.icSemCongressoPortal &&
                        <Mensagem
                            error
                            Header={Mensagens.m51}
                            Content={`O evento código '${this.props.congresso.coCongressoPortal}' não foi encontrado.`} />}

                    {(!this.props.congresso.icSemCongressoPortal) &&
                        <div>
                            
                            {(this.props.congresso.deApresentacao !== '' && this.props.congresso.deApresentacao !== null) &&
                                <p>{this.props.congresso.deApresentacao}</p>
                            }

                            {this.props.congressista &&
                                <div>

                                    <Grid>
                                        <Grid.Row>
                                            <Grid.Column width='14'>
                                                <Header as='h2' className='titulo t2' content={Mensagens.m52} />
                                            </Grid.Column>
                                            {/*computador */}
                                            <MediaQuery minWidth={600}>
                                                <Grid.Column width='2' textAlign='center' verticalAlign='middle'>
                                                    {this.props.linkLogout}
                                                </Grid.Column>
                                            </MediaQuery>
                                        </Grid.Row>
                                    </Grid>

                                    <IsDevIndicator exibeAmbiente={false} size='tiny' content={this.props.congressista.idCongressista} ></IsDevIndicator>
                                    <p><span className='strong'> <Icon name='user' />Nome: </span> {this.props.congressista.nmCongressista} {icInscrito && <span> (em {this.props.congressista.dtInscricao})</span>}</p>

                                    <MediaQuery maxWidth={599}>
                                        <Button className='type2' fluid>{this.props.linkLogout}</Button>
                                    </MediaQuery>
                                    {!icInscrito &&
                                        <Mensagem
                                            error
                                            Header={Mensagens.m53}
                                            Content={Mensagens.m54} />}
                                    {icInscrito &&
                                        <p>
                                            <Button className='button type1' onClick={this.props.onDownloadComprovante}>
                                                <Button.Content ><Icon name='newspaper' />{Mensagens.b16}</Button.Content>
                                            </Button>
                                            {this.props.congresso.icEmiteCracha &&
                                                <Button className='button type1' onClick={this.props.onDownloadCracha} >
                                                    <Button.Content ><Icon name='id badge' />{Mensagens.b17}</Button.Content>
                                                </Button>
                                            }
                                            {(this.props.congresso.icCertificado && icAnyMarcouPresenca) &&
                                                <Button className='button type1' type='button' secondary onClick={this.props.onDownloadCertificado} >
                                                    <Button.Content ><Icon name='download' />{Mensagens.b18}</Button.Content>
                                                </Button>
                                            }
                                        </p>
                                    }

                                </div>
                            }
                        </div>}
                </div>
            }


        </div>
    }
}

export default DetalheCongresso


// WEBPACK FOOTER //
// ./src/components/Congresso/DetalheCongresso.js